/** 与后端字段长度上限一致，供前端 maxlength / 提交前校验使用 */
export const FIELD_LIMITS = {
  order: {
    notes: 1000,
    serviceAddress: 255,
    contactName: 100,
    contactPhone: 50,
    orderId: 50,
    homeId: 50,
    userId: 50,
  },
  checklist: {
    description: 5000,
    itemName: 200,
    section: 50,
    iconUrl: 255,
    /** condition / location / task / time 单项 */
    optionValue: 100,
  },
  technician: {
    name: 100,
    address: 255,
    email: 120,
    phone: 10,
    sinNumber: 64,
    residencyStatus: 64,
  },
  pagination: {
    pageSize: 100,
  },
} as const
